import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';
import { LotRecommendationType } from '@/utils/amplitude/analytics/item/trackLotRecommendationClicked.analytics';

import { ItemCardInfo } from '../types/types';
import { DEFAULT_CARD_DIMENSIONS } from './constants/defaultCardDimensions.constant';

type Props = {
    className?: string;
    hideCardMenu?: boolean;
    itemCardOption: ItemCardInfo;
    itemId: number;
    recommendationPosition?: number;
    recommendationType?: LotRecommendationType | null;
    trackClick?: (itemId: number, index: number) => void;
};

export default function ItemCard({
    className,
    hideCardMenu,
    itemCardOption,
    itemId,
    recommendationPosition,
    recommendationType,
    trackClick,
}: Props) {
    const { dimensions, ItemCardComponent } = itemCardOption;

    const isDesktop = !useIsMobileLayout();

    let dimension = isDesktop ? DEFAULT_CARD_DIMENSIONS.desktop : DEFAULT_CARD_DIMENSIONS.mobile;
    if (dimensions?.desktop && dimensions?.mobile) {
        dimension = dimensions.desktop > dimensions.mobile ? dimensions.desktop : dimensions.mobile;
    }

    return (
        <ItemCardComponent
            className={className}
            dimension={dimension}
            hideCardMenu={hideCardMenu}
            itemId={itemId}
            key={itemId}
            recommendationPosition={recommendationPosition}
            recommendationType={recommendationType}
            trackClick={trackClick}
        />
    );
}
